import axios from "axios";

import { getApiErrorMessage, host, headers } from "./shared";
import { TOKEN_EXCHANGE_ENDPOINT } from "../../constants/importerConstants";
import type { GoogleOAuthCode, GoogleOAuthToken } from "../../types/api";

export const exchangeGoogleOAuthToken = async (
  payload: GoogleOAuthCode,
  accessToken?: string | null,
): Promise<GoogleOAuthToken> => {
  try {
    const response = await axios.post(
      `${host}${TOKEN_EXCHANGE_ENDPOINT}`,
      { google_auth: payload },
      headers(accessToken),
    );
    return response.data;
  } catch (error) {
    const errorMessage = getApiErrorMessage(error);
    throw errorMessage ? new Error(errorMessage) : error;
  }
};
